import { Factoring, Pagination, Common } from '@factorin/domain';

import { withUrl, list, get, ItemRequest } from '../rest';


interface FactoringAgreementListRequest extends Pagination.Request {
    clientUid?: string;
    clientINN?: string;
    clientSignDateRange?: Common.DateRange;
    factorUid?: string;
    factorINN?: string;
    factorSignDateRange?: Common.DateRange;
    supplyAgreementUid?: string;
    number?: string;
    dateRange?: Common.DateRange;
    code?: string;
    uid?: string;
}

const factoringAgreementsPart = withUrl('factoringagreements');
export const factoringagreements = {
    ...list<Factoring.Agreement, FactoringAgreementListRequest>(factoringAgreementsPart()),
    getByOrder: get<ItemRequest, Factoring.ShortAgreement[]>(
        ({ id }) => factoringAgreementsPart({
            path: 'byorderagreement',
            query: {
                orderAgreementUid: id,
            },
        }),
    ),
};
